import Link from 'next/link'
import BlogImage from '@components/blog/components/BlogImage'
import PostMeta from '@components/blog/components/post/PostMeta'
import WrapperAlt from '@components/image/WrapperAlt'
import Icon from '@components/shared/Icon'
import excerptFromHtml from '@utils/html/excerpt'
import { postLink, postImage } from '@components/blog/utils/postLinks'

import styles from '@components/blog/styles/PostListItem.module.css'

function PostListItem ({ post }) {
    return (
        <article className={styles.item}>
            { postHeader(post) }
            { PostMeta(post) }
            { postExcerpt(post) }
        </article>
    )
}

function postHeader (post) {
    const { title, imgAlt, imgTitle } = post
    const link = postLink(post)
    const image = postImage(post)

    return (
        <header>
            <Link href={link}>
                <a>
                    <WrapperAlt>
                        <BlogImage
                            src={image}
                            alt={imgAlt || title}
                            title={imgTitle || imgAlt || title}
                            breakpoint={null} />
                    </WrapperAlt>
                </a>
            </Link>
            <Link href={link}>
                <a>
                    <h2>{ title }</h2>
                </a>
            </Link>
        </header>
    )
}

function postExcerpt (post) {
    const link = postLink(post)

    return (
        <div>
            <p>{ post.shortDesc || excerptFromHtml(post.topContent) }</p>

            <hr />

            <Link href={link}>
                <a className={styles.link}>
                    Przejdź do wpisu <Icon>chevron_right</Icon>
                </a>
            </Link>
        </div>
    )
}

export default PostListItem